export const DATE_RANGE_NAVIGATOR_SET_WEEK_OF_YEAR = 'DATE_RANGE_NAVIGATOR_SET_WEEK_OF_YEAR';
export const DATE_RANGE_NAVIGATOR_SET_DAY = 'DATE_RANGE_NAVIGATOR_SET_DAY';
export const DATE_RANGE_NAVIGATOR_SET_START_DATE = 'DATE_RANGE_NAVIGATOR_SET_START_DATE';
export const DATE_RANGE_NAVIGATOR_SET_DATE_RANGE = 'DATE_RANGE_NAVIGATOR_SET_DATE_RANGE';
